import { Component, EventEmitter, computed, input, Output, forwardRef, signal } from '@angular/core';
import { DisplayMode, SelectComponent, SelectOptionComponent } from '../select.component';
import { MinimapIconShape, Color, MinimapIconSize } from "../../../models/enums";
import { FormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseComponent } from '../../base.component';

@Component({
  selector: 'app-select-minimap-icon',
  imports: [FormsModule, SelectComponent, SelectOptionComponent],
  templateUrl: './select-minimap-icon.component.html',
  styleUrl: './select-minimap-icon.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectMinimapIconComponent),
      multi: true
    }
  ]
})
export class SelectMinimapIconComponent extends BaseComponent implements ControlValueAccessor {
  disabled = input<boolean>(false);
  displayMode = computed(() => this.settings.hideIconsInDropdowns() ? 'textOnly' : 'prefixAndText');

  @Output('selectedValueChange') selectedValueChangeEmitter = new EventEmitter<MinimapIconShape>();

  MinimapIconShape = MinimapIconShape;

  // Internal model for ngModel binding
  internalModel = signal<MinimapIconShape>(MinimapIconShape.Circle);

  private onChange = (value: MinimapIconShape) => {};
  private onTouched = () => {};

  constructor() {
    super();
  }

  // ControlValueAccessor implementation
  writeValue(value: MinimapIconShape): void {
    this.internalModel.set(value);
  }

  registerOnChange(fn: (value: MinimapIconShape) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // Input signals are read-only, so we can't set them directly
    // The disabled state is handled by the parent component
  }

  onModelChange(value: string | undefined) {
    if (value !== undefined) {
      const shapeValue = value as MinimapIconShape;
      this.onChange(shapeValue);
      this.onTouched();
      this.selectedValueChangeEmitter.emit(shapeValue);
    }
  }

  getMinimapIconOptions(shape: MinimapIconShape) {
    return {
      highlight: true,
      highlightColor: Color.White,
      minimapIconShape: shape,
      minimapIconSize: MinimapIconSize.Medium
    };
  }
}
